exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.page-main .daojishi {\n  text-align: center;\n}\n.page-main .daojishi .countdown .i-color {\n  color: #fff;\n  font-size: 16px;\n}\n.page-main .daojishi .countdown .labelcolor {\n  color: #fff;\n  font-size: 16px;\n}\n.page-main .daojishi .countdown .timecolor {\n  padding: 0 5px;\n  color: #fff;\n  font-size: 16px;\n}\n.page-main .daojishi .countdown .endcolor {\n  color: #fff;\n  font-size: 16px;\n}\n", ""]);

// exports
